// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"359b051b","90":"57f2815a","152":"b0a430f1","178":"c7926061","194":"1caca607","493":"3b11a24b","672":"c76b6753","697":"b4479ed7","912":"333e3429"}[chunkId] + ".chunk.js";
};